// import * as mock from './axios.mock'
import axios from 'axios'
import store from '@/store'

const http = axios.create({
  headers: {
    'Accept': 'application/json',
  },
})

const errorPromise = errors =>
  Promise.resolve({
    data: {
      state: 'error',
      data: errors || [{ code: 'internal_server_error' }],
    },
  })

const wrapRequest = request => {
  return request
    .then(response => {
      if (response.data.state !== 'success' || !response.data.data) {
        return errorPromise(response?.data?.errors)
      }
      return response
    })
    .catch(error => {
      return errorPromise(error.response?.data?.errors)
    })
}

/**
 *
 */
const wrapAddState = (request) => {
  return request.then((response) => {
    if (response.status === 200) {
      return {
        data: {
          state: 'success',
          data: response.data,
        },
      }
    }
    throw response
  }).catch(error => {
    return errorPromise(error.response?.data?.errors)
  })
}

/** */
export const getConfig = () => {
  const url = '/config'
  return wrapRequest(wrapAddState(http.get(url)))
}

export const getPackages = () => {
  // return mock.getPackages()
  const url = store.getters.getConfig.domainUltimaRest + '/v1/packs'
  return wrapRequest(http.get(url))
}

export const getRate = (params) => {
  // return mock.getRate(params)
  const url = store.getters.getConfig.domainUltimaRest + '/v1/exchange/current-rate'
  return wrapRequest(http.get(url, { params }))
}

export const getProfile = (params) => {
  // return mock.getProfile(params)
  const url = store.getters.getConfig.domainUltimaRest + '/v1/profile/public'
  return wrapRequest(http.get(url, { params }))
}

export const getFactor = (params) => {
  // return mock.getFactor(params)
  const url = store.getters.getConfig.domainUltimaRest + '/v1/farm/contract/factors'
  return wrapRequest(http.get(url, { params }))
}
